// extracted by mini-css-extract-plugin
export default {"container":"ConnectionPosts_container__cqhU8"};